import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Row,
} from "reactstrap";
import { useDebounce } from "use-debounce";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { PassportTable } from "./PassportTable";

import { getPassportRequest } from "../../store/passport/actions";

const PassportList = () => {
  document.title = "Passaporte virtual | Ecoguias - Admin Dashboard";

  const dispatch = useDispatch();

  const { loading, data } = useSelector((state) => state.Passport);

  const [searchInput, setSearchInput] = useState("");
  const [value] = useDebounce(searchInput, 500);

  // const { success } = useSelector((state) => state.PassportDetails);

  useEffect(() => {
    dispatch(getPassportRequest(value));
  }, [dispatch, value]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="Tabela de passaportes"
            pageTitle="Passaportes vituais"
          />
          <div className="d-flex justify-content-between pb-4 flex-wrap">
            <Input
              type="text"
              style={{ maxWidth: 250 }}
              className="form-control"
              placeholder="Pesquisar..."
              id="search-options"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>

          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Passaportes virtuais</h5>
                </CardHeader>
                <CardBody>
                  <PassportTable
                    searchInput={value}
                    style={{ width: "100%" }}
                    passport={data?.result}
                    loading={loading}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default PassportList;
